module.exports = __webpack_public_path__ + "static/media/logo_vib.e34322fb.svg";